import { attemptChunkLoadRecovery, normalizeRuntimeError } from "./chunkLoadRecovery";

/** Global listeners for stale chunk loads after deployment. */
export function registerChunkLoadRecovery(): void {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "error",
    (event) => {
      // Prefer the underlying Error when present; otherwise normalize the ErrorEvent.
      const payload = event.error ?? event;
      if (attemptChunkLoadRecovery(payload)) {
        event.preventDefault();
        return;
      }
      // Also try the raw event (script target / filename).
      if (payload !== event && attemptChunkLoadRecovery(event)) {
        event.preventDefault();
      }
    },
    true,
  );

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    if (attemptChunkLoadRecovery(reason)) {
      event.preventDefault();
      return;
    }
    // Some browsers wrap the rejection; normalize defensively.
    const normalized = normalizeRuntimeError(reason);
    if (normalized.message && attemptChunkLoadRecovery(normalized.message)) {
      event.preventDefault();
    }
  });
}
